export default "__VITE_ASSET__zybngnM6__"